import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Post from '../PlaygroundTab/Post/Post';
import PostSkeleton from '../PlaygroundTab/Post/PostSkeleton';
import { UserType } from '../../../types/userType';
import { PostProps } from '../../../types/postType';

interface PostsTabProps {
  searchQuery: string;
  posts: PostProps[];
  currentUser: UserType | null;
  isLoading?: boolean;
}

const PostsTab: React.FC<PostsTabProps> = ({ searchQuery, posts, currentUser, isLoading = false }) => {
  const navigate = useNavigate();

  const handlePostDeleted = (postId: number) => {
    console.log(`Post ${postId} deleted`);
  };

  const handleReplyClick = () => {
    console.log('Reply clicked');
  };

  const handlePostClick = useCallback((postSlug: string) => {
    navigate(`/posts/${postSlug}`);
  }, [navigate]);

  if (isLoading) {
    return (
      <div className="posts-tab">
        <PostSkeleton />
        <PostSkeleton />
        <PostSkeleton />
      </div>
    );
  }

  if (!posts.length) {
    return <div className="posts-tab">No posts found</div>;
  }

  return (
    <div className="posts-tab">
      {posts.map((post) => (
        <Post
          key={post.id}
          {...post}
          onPostDeleted={handlePostDeleted}
          currentUser={currentUser}
          currentUserId={currentUser?.id?.toString() ?? ''}
          isNewPost={false}
          onReplyClick={handleReplyClick}
          onClick={() => handlePostClick(post.slug)}
        />
      ))}
    </div>
  );
};

export default PostsTab;
